module.exports = __webpack_public_path__ + "media/images/step_01-3028d8cc05e77b5faeb59508864f87b8.gif";